module.exports = __webpack_public_path__ + "assets/img/anquan.d56ad9e5.png";